import bulkSubmitFhirResources from '../functions/bulkSubmitFhirResourcesAPI';

const extractResourcesFromBundleEntry = (entry, resourcesArray) => {
    if (!resourcesArray) {
        resourcesArray = [];
    }
    let resource = entry.resource;
    if (resource && resource.resourceType) {
        if (resource.resourceType === "Bundle") {
            if (Array.isArray(resource.entry)) {
                for (const entry of resource.entry) {
                    resourcesArray = extractResourcesFromBundleEntry(entry, resourcesArray);
                }
            }
        } else {
            resourcesArray.push(resource)
        }
    }
    return resourcesArray
}

const submitBulkResources = async (apiToken, fhirEntryState, silent, isAdmin) => {
    let fhirJson;
    let submit = true;
    let resourceSetToSubmit = [];
    if (!(fhirEntryState.fhirBulkEntry)) {
        alert("No data submitted.");
        return;
    }
    try {
        if (typeof (fhirEntryState.fhirBulkEntry) === "string") {
            fhirJson = JSON.parse(fhirEntryState.fhirBulkEntry);
        } else {
            fhirJson = fhirEntryState.fhirBulkEntry;
        }
        try {
            if (!Array.isArray(fhirJson) && fhirJson["resourceType"] &&
                typeof fhirJson["resourceType"] === 'string') {
                if (fhirJson["resourceType"] === "Bundle") {
                    if (Array.isArray(fhirJson.entry) && fhirJson.entry.length > 0) {
                        let resourcesArray = [];
                        for (const entry of fhirJson.entry) {
                            resourcesArray = extractResourcesFromBundleEntry(entry, resourcesArray);
                        }
                        fhirJson = resourcesArray;
                    } else {
                        alert("This is the JSON Bulk Entry page. It does not work with an improperly structured Bundle.");
                        submit = false;
                    }
                } else {
                    alert("This is the JSON Bulk Entry page. It's to be used only for multiple entries.");
                    submit = false;
                }
            }
        } catch (e) {
            console.log("ERROR in submitBulkResources preparation");
            console.log(e);
        }
        if (!isAdmin && Array.isArray(fhirJson) && fhirJson.length > 1000) {
            alert("You're not allowed to submit more than 1,000 resources at a time in the JSON Bulk Entry.");
            submit = false;
        } else if (!isAdmin && Object.keys(fhirJson).length > 1000) {
            alert("You're not allowed to submit more than 1,000 resources at a time in the JSON Bulk Entry.");
            submit = false;
        } else {
            for (let x in fhirJson) {
                let resource = fhirJson[x];
                if (!resource.resourceType) {
                    alert("Resource type is missing. Please fix before submitting.");
                    submit = false;
                    break;
                }
                let title = "";
                if (resource.title && typeof resource.title === "string" && resource.title.trim()) {
                    title = resource.title;
                } else if (resource.name) {
                    if (typeof resource.name === "string" && resource.name.trim()) {
                        title = resource.name;
                    } else if (Array.isArray(resource.name) && resource.name.length > 0 &&
                        resource.name[0].text && resource.name[0].text.trim() !== "") {
                        title = resource.name[0].text;
                    }
                }
                if (title === "") {
                    title = resource.resourceType + " submitted as Resource " + (parseInt(x) + 1) + " of " + fhirJson.length;
                }
                let resourceEntry = { "fhirJson": resource, "title": title };
                resourceSetToSubmit.push(resourceEntry);
            }
        }
    } catch {
        submit = false;
        alert("Improper JSON format");
    }
    //Warnings if the JSON is missing a resourceType or title field

    if (submit) {

        let response = await bulkSubmitFhirResources(apiToken, JSON.stringify(resourceSetToSubmit), fhirEntryState.status, fhirEntryState.tool);

        if (response?.success) {
            if (response.warnings?.length > 0) {
                console.log(response.warnings.join(", "));
            }
            if (!silent) {
                alert("All resources successfully submitted.");
            }
            return response.fois;
        } else {
            alert("Problem submitting resources.");
            return false;
        }
    } else {
        //console.log("There's a problem with the JSON format. It needs to be an array of resources.")
    }
}

export default submitBulkResources;